import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { apiAxios } from "../../utils/apiAxios";
import { toast } from "react-toastify";
const DescriptionCell = ({ description }: { description: string }) => {
  const [expanded, setExpanded] = React.useState(false);

  const limit = 80;
  const isLong = description && description.length > limit;

  return (
    <div style={{ maxWidth: "250px", wordBreak: "break-word" }}>
      <span>
        {expanded || !isLong
          ? description
          : `${description.slice(0, limit)}...`}
      </span>

      {isLong && (
      <span
  className="view-more-section"
  onClick={() => setExpanded(!expanded)}
>
  {expanded ? "View Less" : "View More"}
</span>
      )}
    </div>
  );
};
const DentistContactSupport = () => {
  const [showReplyModal, setShowReplyModal] = useState(false);
const [selectedReply, setSelectedReply] = useState("");
const [selectedDate, setSelectedDate] = useState("");
   const [caseInfo, setCaseInfo] = useState<any>(null);
    const [toothList, setToothList] = useState<any[]>([]);
    const [showCaseModal, setShowCaseModal] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [replyHistory, setReplyHistory] = useState<any[]>([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_File_BASE_URL = process.env.REACT_APP_API_PATH_URL;
  const APIDentistCase = `${API_BASE_URL}/Dentist`;
  const handleViewFile = (filePath: string) => {
    if (!filePath) {
      toast.error("No file available");
      return;
    }

    // 👇 open file in new tab
    window.open(`${API_File_BASE_URL}/${filePath}`, "_blank");
  };
  const fetchSupportTickets = async (pageNumber = page, size = pageSize) => {
    try {
      setLoading(true);
      const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
      const res = await apiAxios.get(
        `${API_BASE_URL}/Support/get-dentist-all?ClinicID=${selectedClinic.clinicID}&page=${pageNumber}&pageSize=${size}`
      );

      if (res.data?.isSuccess) {
        const result = res.data.singleData;
     
     const formatted = result.items.map((item: any, index: number) => ({
  id: index + 1 + (pageNumber - 1) * size,
   ticketId: item.id,
  dentistName: item.dentistName || "-",
  issue: item.issueType,
  priority: item.priority,
  description: item.description,
  file: item.filePath,
  status: item.status,
  orderID: item.orderID,
  adminReply: item.adminReply,

  date: new Date(item.createdDate).toLocaleDateString("en-GB"),
  replyDate: item.createdDate, 
}));

        setData(formatted);
        setTotalRows(result.totalRecords);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load support tickets");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSupportTickets(page, pageSize);
  }, [page, pageSize]);
const fetchReplyHistory = async (ticketId: number) => {
  try {
    const res = await apiAxios.get(
      `${API_BASE_URL}/Support/GetReplyHistory/${ticketId}`
    );

    setReplyHistory(res.data || []);
  } catch (error) {
    console.error(error);
    toast.error("Failed to load reply history");
  }
};
  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number) => {
    setPageSize(newPerPage);
    setPage(1);
  };

  const openCaseDetail = async (caseId: number) => {
    try {
      const res = await apiAxios.post(`${APIDentistCase}/GetReuploadScanDetail`, { CaseID: caseId });

      const data = res.data.singleData || res.data; // ✅ Adjust based on API response

      if (!data || data.length === 0) return;

      // ✅ First item = case info
      setCaseInfo(data[0]);

      // ✅ Full list = tooth details
      setToothList(data);

      setShowCaseModal(true);

    } catch (err) {
      console.error(err);
      toast.error("Failed to load case");
    }
  };

  const columns: any = [
    
    {
      name: "Case",
      cell: (row: any) => (
        <span
          style={{  cursor: "pointer", fontWeight: 500 }}
          onClick={() => openCaseDetail(row.orderID)}
        >
          TZ{row.orderID}
        </span>
      )
    },
 {
  name: "Issue",

  cell: (row: any) => (
    <div
      title={row.issue}
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "200px"
      }}
    >
      {row.issue}
    </div>
  )
},
    {
      name: "Priority",
      cell: (row: any) => (
        <span
          className={`badge ${row.priority === "High" ? "bg-danger" : "bg-secondary"
            }`}
        >
          {row.priority}
        </span>
      ),
    },
{
  name: "Description",
  cell: (row: any) => (
    <DescriptionCell description={row.description || ""} />
  ),
},
    {
      name: "File",
      cell: (row: any) =>
        row.file ? (
          <span
            className="text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => handleViewFile(row.file)}
          >
            View
          </span>
        ) : (
          "No File"
        ),
    },
    {
      name: "Date",
      selector: (row: any) => row.date,
    },
    {
      name: "Status",
      cell: (row: any) => (
        <span
          className={`badge ${row.status === "Pending"
            ? "bg-warning text-dark"
            : "bg-success"
            }`}
        >
          {row.status}
        </span>
      ),
    },
{
  name: "Admin Reply",
  sortable: true,
  cell: (row: any) => (
    <button
      className="btn btn-sm btn-primary"
      // onClick={() => {
      //   setSelectedReply(row.adminReply || "");
      //   setSelectedDate(row.replyDate);
      //   setShowReplyModal(true);
      // }}
      onClick={async () => {
  await fetchReplyHistory(row.ticketId);
  setShowReplyModal(true);
}}
    >
      <i className="bi bi-reply-fill me-1"></i>
      Reply
    </button>
  ),
}
  ];

  return (
    
    <div className="container mt-4">
      <h4 className="mb-4">Contact Support</h4>

      <div className="premium-card p-3">
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          paginationServer // 🔥 VERY IMPORTANT
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          highlightOnHover
          striped
          responsive
          noDataComponent="No support tickets found"
        />
      </div>
       {showCaseModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">

            <div className="modal-header">
              <h5>Case Details</h5>

              <button onClick={() => setShowCaseModal(false)} className="custom-close-btn raise-ticket-closebtn btn-close "><i className="bi bi-x customcross"></i></button>
            </div>

            <div className="modal-body">

              {/* 🔹 CASE INFO */}
              {caseInfo && (
                <div className="mb-3 border-bottom pb-2">
                  <div className="carse-id-text"><strong>Case ID:</strong> TZ{caseInfo.caseID}</div>
                  {/* <div className="carse-id-text"><strong>Order ID:</strong> {caseInfo.orderID}</div> */}
                  <div className="carse-id-text"><strong>Patient:</strong> {caseInfo.patientName}</div>
                  <div className="carse-id-text">
                    <strong>Status:</strong>
                    <span className="badge bg-warning ms-2">
                      {caseInfo.dentistTag}
                    </span>
                  </div >
                  <div className="carse-id-text">
                    <strong>ETA:</strong>{" "}
                    {new Date(caseInfo.expectedEta).toLocaleString()}
                  </div>
                </div>
              )}

              {/* 🔹 TOOTH TABLE */}
              <div>
                <h6>Tooth Details</h6>

                <table className="table table-bordered table-sm">
                  <thead className="table-light">
                    <tr>
                      <th>Tooth No</th>
                      <th>Shade</th>
                      <th>Material</th>
                    </tr>
                  </thead>
                  <tbody>
                    {toothList.map((t, i) => (
                      <tr key={i}>
                        <td>{t.toothNumber}</td>
                        <td>{t.shade}</td>
                        <td>{t.materialName}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {showReplyModal && (
  <div className="custom-modal-overlay reply-commentsection">
    <div
      className="custom-modal"
       style={{
    maxWidth: "650px",
    marginTop: "20px"
  }}
    >
      <div className="modal-header">
        <h5>
          <i className="bi bi-reply-fill text-primary me-2"></i>
          Admin Reply
        </h5>

        <button
          onClick={() => setShowReplyModal(false)}
          className="custom-close-btn raise-ticket-closebtn btn-close"
        >
          <i className="bi bi-x customcross"></i>
        </button>
      </div>

     <div className="modal-body">
  <div className="d-flex justify-content-between mb-3 border-bottom py-2">
    {/* <div>
      <strong>Date:</strong>{" "}
      {selectedDate &&
        new Date(selectedDate).toLocaleDateString("en-GB")}
    </div>

    <div>
      <strong>Time:</strong>{" "}
      {selectedDate &&
        new Date(selectedDate).toLocaleTimeString()}
    </div> */}
  </div>

 <div
  className="border rounded p-3 bg-light thin-scrollbar"
  style={{
    maxHeight: "250px",
    overflowY: "auto",
    lineHeight: "1.8",
  }}
>
  {replyHistory.length > 0 ? (
    replyHistory.map((item: any, index: number) => (
      <div
        key={index}
        className={index !== replyHistory.length - 1 ? "border-bottom pb-2 mb-2" : ""}
      >
        <div className="small text-muted mb-1">
          {new Date(item.repliedDate).toLocaleDateString("en-GB")}{" "}
          {new Date(item.repliedDate).toLocaleTimeString()}
        </div>

        <div style={{ whiteSpace: "pre-wrap" }}>
          {item.adminReply}
        </div>
      </div>
    ))
  ) : (
    "No reply available."
  )}
</div>
</div>
    </div>
  </div>
)}
    </div>
  );
};

export default DentistContactSupport;